import { ChronoUnit } from "@js-joda/core";
import { TIME_UNITS } from "components/basic/dropdowns/time-unit-dropdown/timeUnits";

const validateUnitValue = (value: ChronoUnit | string) => {
  if (typeof value === "string") {
    return TIME_UNITS.find(unit => unit.enumValue === value)?.value as ChronoUnit;
  }
  return value;
};

export default validateUnitValue;
